import { Model } from '@elementary/common-ui/types';
import { ArrayChanges } from 'shared/types';
import { BulkEditProperty, BulkEditPropertyType } from './types';

export const bulkEditPropertyTypeMap: Record<
  BulkEditProperty,
  BulkEditPropertyType
> = { tags: 'array', owners: 'array', description: 'string' };

export const getModifiedTableData = (
  initialTableData: Model[],
  curTableData: Model[],
  property: BulkEditProperty,
  propertyType: BulkEditPropertyType,
) => {
  const isArrayProperty = propertyType === 'array';

  return curTableData.filter((model, index) => {
    const initialModel = initialTableData[index];

    if (isArrayProperty) {
      const currValue = model?.[property] as string[] | undefined;
      const initialValue = initialModel?.[property] as string[] | undefined;

      return (
        JSON.stringify(
          currValue?.slice().sort((a, b) => a.localeCompare(b)),
        ) !==
        JSON.stringify(initialValue?.slice().sort((a, b) => a.localeCompare(b)))
      );
    }

    const currValue = model?.[property] as string | undefined;
    const initialValue = initialModel?.[property] as string | undefined;

    return currValue?.toString() !== initialValue?.toString();
  });
};

export const getArrayPropertyChanges = (
  initialValues: string[],
  currentValues: string[],
): ArrayChanges => {
  const uniqueInitialValues = [...new Set(initialValues)];
  const uniqueCurrentValues = [...new Set(currentValues)];

  const added = uniqueCurrentValues.filter(
    (value) => !uniqueInitialValues.includes(value),
  );
  const removed = uniqueInitialValues.filter(
    (value) => !uniqueCurrentValues.includes(value),
  );

  return {
    added: added.length > 0 ? added : null,
    removed: removed.length > 0 ? removed : null,
  };
};
